import * as React from "react";
import { DatePicker as BaseDatePicker, DatePickerProps } from 'react-toolbox/lib/date_picker';

const theme = require("./DatePickerTheme.scss");

export function DatePicker(props: DatePickerProps) {
    return <BaseDatePicker {...{ theme, ...props }} />
}